import { getWindow } from "@faire/web/common/globals/getWindow";

import {
  PerformanceEvent,
  getKeyForEvent,
} from "./__internal__/PerformanceEvent";
import { PerformanceBreakdown } from "./PerformanceBreakdown";

function getLatestMark(
  event: PerformanceEvent
): DOMHighResTimeStamp | undefined {
  const performance = getWindow()?.performance;
  if (!performance) {
    return undefined;
  }

  const key = getKeyForEvent(event);
  return performance.getEntriesByName?.(key).slice(-1)?.[0]?.startTime;
}

export function getGlobalPerformanceMarks(): Pick<
  PerformanceBreakdown,
  "htmlStarted" | "mainJsExecuted"
> {
  return {
    htmlStarted: getLatestMark({ name: "htmlStarted" }),
    mainJsExecuted: getLatestMark({ name: "mainJsExecuted" }),
  };
}
